import React from 'react';
import { useFormikContext } from 'formik';
import { MdLockOutline } from 'react-icons/md';

import Toggle from '../form/Toggle';
import InfoTooltip from './InfoTooltip';
import { useTranslation } from 'react-i18next';

const PrivateToggle = () => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { t } = useTranslation(['events']);
  const togglePrivacy = () => {
    setFieldValue('private', !values.private);
  };

  return (
    <div className="w-full mr-10 pt-6 text-base text-gray-500 flex items-center justify-between">
      <div className="flex items-center">
        <MdLockOutline size={20} className="mr-2" />
        {t('events:host.privateEvent')}
        <InfoTooltip
          id="private-event-tooltip"
          message={t('events:host.privateEventTooltip')}
        />
      </div>

      <Toggle isActive={values.private} onClick={togglePrivacy} />
    </div>
  );
};

export default PrivateToggle;
